<template>
    <div>
        <div class="header noselect" :style="{'background': (type === 'application')?headerColors[1]:headerColors[0]}">
            {{title}}
            <md-icon class="edit-icon" v-if="type === 'service'" @click.native="goToService(data.id)">edit</md-icon>
            <md-icon @click.native="closeSidebar">clear</md-icon>
        </div>
        <div class="content" v-if="type === 'application'">
            <div class="tab-tools">
                <div :class="[showStatus?'active':'']" @click="showStatus = true">Status</div>
                <div :class="[!showStatus?'active':'']" @click="showStatus = false">
                    Errors
                    <i v-if="errors && errors.length > 0">{{unwatchedErrorsCount}}</i>
                </div>
            </div>
            <div v-if="showStatus">
                <div class="details-block">
                    <div class="key">Status</div>
                    <div>
                        <md-icon :class="[data.levelOfFunctioning==1?'active':'']">fiber_manual_record</md-icon>
                        <span v-if="data.levelOfFunctioning==1">ONLINE</span>
                        <span v-else>OFFLINE</span>
                    </div>
                </div>
                <hr/>
                <div class="details-block">
                    <div class="key">developers</div>
                    <div>
                        <p v-for="(developer, index) in data.developers">{{developer.name}}
                            ({{developer.contactMail}})</p>
                    </div>
                </div>
                <div class="details-block">
                    <div class="key">customers</div>
                    <div>
                        <p v-for="(customer, index) in data.customers">{{customer.name}} ({{customer.contactName}}:
                            {{customer.contactMail}})</p>
                    </div>
                </div>
                <hr/>
                <div class="details-block">
                    <div class="key">services</div>
                    <div>
                        <div v-for="(service, index) in data.services" @click="selectService(service)"
                             class="service-item">
                            <md-icon :class="[service.online?'active':'']">fiber_manual_record</md-icon>
                            <span>{{service.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!showStatus">
                <div class="details-block notification-item" v-for="message in errors" v-if="message.isRead==false">
                    <div @click="toggleMessage(message)">
                        <md-icon>fiber_manual_record</md-icon>
                        <div class="service-name">{{message.serviceName}}</div>
                        <div v-if="message.show">
                            <div class="time">
                                <span>[{{message.time | dateFormat}}]</span>
                            </div>
                            <div class="service-message">
                                <div class="topic">{{message.topic}}</div>
                                {{message.message}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-if="type === 'service'">
            <div class="tab-tools">
                <div :class="[showStatus?'active':'']" @click="showStatus = true">Status</div>
                <div :class="[!showStatus?'active':'']" @click="showStatus = false">
                    Errors
                    <i v-if="errors && errors.length > 0">{{errors.length}}</i>
                </div>
            </div>
            <div v-if="showStatus">
                <div class="details-block">
                    <div class="key">Status</div>
                    <div>
                        <md-icon :class="[data.online?'active':'']">fiber_manual_record</md-icon>
                        <span v-if="data.online">ONLINE</span>
                        <span v-else>OFFLINE</span>
                    </div>
                </div>
                <div class="details-block">
                    <div class="key">since</div>
                    <div>
                        {{data.startOnline | dateFormat}}
                    </div>
                </div>
                <div class="details-block">
                    <div class="key">latest resp.</div>
                    <div>
                        {{data.latestResponse | dateFormat}}
                    </div>
                </div>
                <hr/>
                <div class="details-block">
                    <div class="key">class</div>
                    <div>
                        {{data.class}}
                    </div>
                </div>
                <div class="details-block">
                    <div class="key">location</div>
                    <div>
                        <a :href="url" v-for="url in data.urls">{{url}} </a>
                    </div>
                </div>
                <div class="details-block">
                    <div class="key">version</div>
                    <div>
                        {{data.version || '0.0'}}
                    </div>
                </div>
                <hr/>
                <div class="details-block">
                    <div class="key">developers</div>
                    <div>
                        <p v-for="(developer, index) in data.developers">{{developer.name}}
                            ({{developer.contactMail}})</p>
                    </div>
                </div>
                <hr/>
                <div class="details-block" v-if="data.accuracy">
                    <div class="key">accuracy</div>
                    <div>
                        <div>
                            {{parseFloat(data.accuracy * 100).toFixed(2) || 0}}%
                        </div>
                    </div>
                </div>
                <div class="details-block">
                    <div class="key">calls</div>
                    <div>
                        <div>
                            {{data.callsCount || 0}} last 24 hrs
                        </div>
                    </div>
                </div>
                <div class="details-block">
                    <div class="key">Uptime</div>
                    <div>
                        <div>
                            {{parseInt(data.uptime) || 0}}ms
                        </div>
                    </div>
                </div>
                <div class="details-block">
                    <div class="key">response time</div>
                    <div>
                        <div>
                            {{parseInt(data.responseTime) || 0}}ms
                        </div>
                    </div>
                </div>
                <div class="chart-container">
                    <div class="header noselect">
                        Historical performance
                        <md-icon @click.native="$emit('showDetailed')">call_made</md-icon>
                    </div>
                    <div class="chart-switcher">
                        <div :class="[dataChartKey === 'accuracy'?'active':'']"
                             @click="setChartData(data.id,'accuracy')">Accuracy
                        </div>
                        <div :class="[dataChartKey === 'responseTime'?'active':'']"
                             @click="setChartData(data.id,'responseTime')">Response Time
                        </div>
                        <div :class="[dataChartKey === 'serviceState'?'active':'']"
                             @click="setChartData(data.id,'serviceState')">Online/Offline
                        </div>
                        <div :class="[dataChartKey === 'calls'?'active':'']" @click="setChartData(data.id, 'calls')">
                            Calls
                        </div>
                    </div>
                    <line-chart class="line-chart" :chart-data="chartData" :options="chartOptions"
                                :height="240"></line-chart>
                </div>
            </div>
            <div v-if="!showStatus">
                <div class="details-block notification-item" v-for="message in errors" v-if="message.isRead==false">
                    <div @click="toggleMessage(message)">
                        <md-icon>fiber_manual_record</md-icon>
                        <div class="service-name">{{message.serviceName}}</div>
                        <div v-if="message.show">
                            <div class="time">
                                <span>[{{message.time | dateFormat}}]</span>
                            </div>
                            <div class="service-message">
                                <div class="topic">{{message.topic}}</div>
                                {{message.message}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-if="type === 'notifications'">
            <div :class="['details-block', 'notification-item', (message.isRead)?'isread':'unread']"
                 v-for="message in data">
                <div>
                    <md-icon class="check" @click.native="clickOnMessage(message)">check</md-icon>
                    <div class="service-name">{{message.serviceName}}</div>
                    <div class="time">
                        <span>[{{message.time | dateFormat}}]</span>
                    </div>
                    <div class="service-message">
                        <div class="topic">{{message.topic}}</div>
                        {{message.message}}
                    </div>
                </div>
            </div>
        </div>
        <div class="notification-bar">
            <md-icon class="check-all" :class="{checked: isAllChecked}" @click.native="checkAll">check</md-icon> Mark all as read
        </div>
    </div>
</template>

<script>
    import managedata from '../helpers/managedata.js';

    const moment = require('moment');

    export default {
        name: 'sidebar',
        components: {},
        props: [
            'title',
            'type', // application, service or notifications
            'data',
            'errors',
        ],
        data() {
            return {
                headerColors: ['#0098FF', '#4a90e2'],
                chartOptions: {},
                chartData: {},
                dataChartKey: null,
                showStatus: true,
            };
        },
        created() {
            this.setChartOptions();
        },
        mounted() {
            if (this.type === 'service')
                this.setChartData(this.data.id);
        },
        updated() {
        },
        watch: {
            type: function (val, oldVal) {
                if (val === 'service' && oldVal === 'application') {
                    this.setChartData(this.data.id);
                }
            },
        },
        methods: {
            toggleMessage: function (message) {
                message.show = !message.show;
                this.$forceUpdate();
            },
            clickOnMessage: function (message) {
                const self = this;
                /*this.data.forEach(err => {
                  if (err.message === message.message &&
                    err.serviceId && message.serviceId &&
                    err.time && message.time &&
                    err.serviceName && message.serviceName &&
                    err.topic && message.topic
                  ) {
                    err.isRead = true;
                  }
                });*/
                managedata.markAlarmMessageAsRead(message).then(() => {
                    message.isRead = true;
                }).catch(() => {

                });
            },
            goToService: function (id) {
                this.$router.push({name: 'serviceManagement:id', params: {id}});
            },
            closeSidebar: function () {
                this.$emit('closeSidebar', this.type);
            },
            getChartsData: function (id, dataKey, cb) {
                let hrdData = [];
                if (id) {
                    const from = moment().subtract(1, 'months').startOf('day').toDate();
                    const to = new Date();
                    const demarcate = false;
                    const aggregator = (dataKey === 'calls') ? 'count' : 'mean';
                    const group = 'time(1d)';
                    managedata.getDetailsOfService(id, from, to, (response) => {
                        this.data.uptime = response.body.responseTime;
                        if (response.body.callsInInterval) {
                            hrdData = response.body.callsInInterval.map(item => {
                                return {
                                    time: item.time,
                                    responseTime: Math.round(item.mean_responseTime),
                                    algorithmValue: '13',
                                    actualValue: '17',
                                    error: false,
                                    accuracy: item.mean_accuracy,
                                    serviceState: item.mean_uptime,
                                    calls: item.mean_quantity,
                                };
                            });
                        }
                        cb(hrdData);
                    }, (err) => {
                        this.$parent.openSnackbarError(err);
                        cb(err);
                    });
                }
            },
            setChartData: function (id, dataKey) {
                let self = this;
                let background = 'rgba(128,198,255,0.35)';
                let borderBg = 'rgba(128,198,255,1)';
                let data = [];
                let labels = [];
                if (!id) {
                    id = 0;
                }
                if (!dataKey) {
                    dataKey = 'accuracy';
                }
                this.dataChartKey = dataKey;
                this.getChartsData(id, dataKey, function (detailedData) {
                    let promises = detailedData.map((item) => {
                        let value;
                        if (typeof item[dataKey] === 'boolean') {
                            value = item[dataKey] ? 1 : 0;
                        } else {
                            if (item[dataKey]) {
                                value = Math.round(item[dataKey]);
                            } else {
                                value = 0;
                            }
                        }
                        data.push(value);
                        labels.push(moment(item.time).format('DD-MM-YY HH:mm'));
                        return value;
                    });
                    Promise.all(promises).then(() => {
                        self.chartData = {
                            datasets: [{
                                label: '',
                                backgroundColor: background,
                                borderColor: borderBg,
                                cubicInterpolationMode: 'linear',
                                lineTension: 0,
                                borderWidth: 2,
                                data,
                            }],
                            labels,
                        };
                        self.$forceUpdate();
                    });
                });
            },
            setChartOptions: function () {
                this.chartOptions = {
                    elements: {
                        point: {
                            radius: 0,
                        },
                        line: {stepped: true},
                    },
                    legend: {
                        display: false,
                    },
                    layout: {
                        padding: 0,
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: true,
                                color: 'rgba(132, 200, 205, 0.8)',
                            },
                            display: true,
                            type: 'time',
                            scaleLabel: {
                                display: false,
                            },
                            time: {
                                parser: (value) => {
                                    return moment(value, 'DD-MM-YY HH:mm');
                                },
                                unit: 'day',
                                displayFormats: {
                                    millisecond: 'DD-MM',
                                    second: 'DD-MM',
                                    minute: 'DD-MM',
                                    hour: 'DD-MM',
                                    day: 'DD-MM',
                                    week: 'DD-MM',
                                    month: 'DD-MM',
                                    quarter: 'DD-MM',
                                    year: 'DD-MM',
                                },
                            },
                            ticks: {
                                fontSize: 10,
                                minRotation: 50,
                                maxRotation: 50,
                                autoSkip: true,
                                callback: function (value, index, values) {
                                    if (index != 0 && index !== values.length - 1)
                                        return value;
                                },
                            },
                        }],
                        yAxes: [{
                            gridLines: {
                                display: true,
                                color: 'rgba(132, 200, 205, 0.8)',
                            },
                            display: true,
                            fontSize: 8,
                            position: 'left',
                            ticks: {
                                display: false,
                            },
                        }],
                    },
                };
                this.$forceUpdate();
            },
            selectService: function (service) {
                this.$emit('selectService', Object.assign({...service}, {selected: false}));
            },
            checkAll() {
                if (!this.isAllChecked) {
                    let promises = [];
                    let size = 500;
                    let count = Math.ceil(this.data.filter(e => !e.isRead).length / size);
                    for (let i = 0; i < count; i++) {
                        let data = this.data.filter(e => !e.isRead).splice(i*size, size);
                        data.forEach(e => {
                            if (e.context) {
                                delete e.context;
                            }
                        });
                        promises.push(managedata.markAlarmMessageAsRead(data).catch(err => {
                            console.log(err);
                        }))
                    }
                    Promise.all(promises).then(() => {
                        this.data.forEach(e => e.isRead = true);
                    });
                }
            }
        },
        computed: {
            unwatchedErrorsCount() {
                const unwatchedErrors = this.errors.filter(error => !error.isWatched);
                console.log('unwatchedErrorsCount', unwatchedErrors);
                return unwatchedErrors.length;
            },
            isAllChecked() {
                return !this.data.filter(e => !e.isRead).length;
            }
        },
    };
</script>

<style scoped>
    .check {
        position: absolute;
        right: 0;
        color: #ccc !important;
        cursor: pointer;
    }

    .details-block.isread .md-icon.check {
        color: rgb(0, 152, 255) !important;
    }

    .header {
        width: 100%;
        position: absolute;
        padding: 15px;
        color: #fff;
        text-transform: uppercase;
        font-size: 0.9rem;
        min-height: 50px;
        cursor: default;
        text-outline: 0;
        padding-right: 80px;
    }

    .header i {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
        font-size: 0.9rem;
    }

    .header i.edit-icon {
        right: 50px;
    }

    .content {
        overflow-y: auto;
        overflow-x: hidden;
        height: calc(100% - 100px);
        margin-top: 50px;
    }

    .content > hr {
        margin: 5px 0 10px;
    }

    .details-block:first-of-type {
        padding-top: 10px;
    }

    .details-block {
        padding: 0 20px 5px;
        font-size: 0.8rem;
        color: #6f6f6f;
        display: flex;
        flex-wrap: wrap;
    }

    .details-block > div {
        width: 68%;
    }

    .details-block > div:first-of-type {
        width: 32%;
        text-transform: lowercase;
    }

    .details-block a {
        font-size: 0.6rem;
    }

    .details-block.notification-item {
        padding: 10px 20px 5px;
    }

    .details-block.notification-item:hover {
        background: #f3f3f3;
    }

    .details-block.notification-item > div {
        width: 100%;
        text-transform: none;
        position: relative;
        padding-right: 20px;
    }

    .details-block.notification-item .md-icon {
        font-size: 1.2rem;
    }

    .details-block.notification-item .topic {
        text-transform: uppercase;
        font-weight: 800;
    }

    .details-block.notification-item .time {
        padding: 0 20px;
        color: #4e4e4e;
    }

    .details-block.notification-item .service-name {
        font-weight: 800;
        display: inline-block;
        font-size: 0.9rem;
        color: #4e4e4e;
    }

    .details-block.notification-item .service-message {
        color: #7b7b7b;
        font-size: 0.75rem;
        padding-left: 20px;
        margin: 10px 0 20px;
    }

    .content .details-block a,
    .content .details-block a:hover {
        color: #4a90e2;
    }

    .details-block p {
        margin: 0;
    }

    .details-block .md-icon {
        color: #d0021b;
        font-size: 1rem;
        min-width: auto;
        min-height: auto;
        width: auto;
        height: auto;
    }

    .details-block.unread .md-icon {
        color: #d0021b;
    }

    .details-block.isread .md-icon {
        color: #02d015;
    }

    .details-block .md-icon.active {
        color: #7ed321;
    }

    .chart-container {

    }

    .chart-container .header {
        color: #6f6f6f;
        font-size: 0.8rem;
        padding: 20px 20px 5px;
        position: relative;
    }

    .chart-switcher {
        display: flex;
        font-size: 0.7rem;
        padding: 0 20px 10px;
        justify-content: space-around;
    }

    .chart-switcher > div {
        padding: 0 2px;
        cursor: pointer;
    }

    .chart-switcher > div.active {
        text-decoration: underline;
    }

    .service-item:hover {
        cursor: pointer;
        color: #000;
    }

    .tab-tools {
        display: flex;
        padding: 10px 10px 0;
        text-transform: uppercase;
    }

    .tab-tools div {
        margin: 0 10px;
        font-size: 12px;
        cursor: pointer;
        color: #6f6f6f;
        position: relative;
    }

    .tab-tools div:hover {
        color: #000;
    }

    .tab-tools div.active {
        color: #000;
        border-bottom: 2px solid rgb(74, 144, 226);
    }

    .tab-tools div i {
        position: absolute;
        left: 56px;
        top: 1px;
        background: #d0021b;
        color: #fff;
        font-size: .65rem;
        border-radius: 10px;
        font-style: normal;
        font-family: 'WidgetBrain';
        width: auto;
        min-width: 16px;
        height: 16px;
        line-height: 12px;
        text-align: center;
        padding: 3px;
    }

    .notification-bar {
        position: fixed;
        bottom: 0;
        width: 400px;
        height: 50px;
        background-color: #fff;
        z-index: 9999;
        padding: 13px;
        box-sizing: border-box;
        border-top: 1px solid #ccc;
    }

    .check-all {
        color: #ccc;
        cursor: pointer;
    }

    .check-all.checked {
        color: rgb(74, 144, 226);
    }
</style>



// WEBPACK FOOTER //
// sidebar.vue?5f4b6c99